import { createSlice } from "@reduxjs/toolkit";
import * as promise from "bluebird";
import { format as formatTZ } from "date-fns-tz";

import { executeUploadFile, executeUploadZip } from "../api/FileApi";
import { storeKeyName } from "../common/AppConstant";
import { checkPromiseMapError, handleError } from "../common/ErrorUtil";

/**
 * Slice.
 *
 * @type {object}
 */
export const slice = createSlice({
  // Slice名
  name: storeKeyName.register,

  // 初期State
  initialState: {
    // 読み込み中フラグ（true: 表示、false: 非表示）
    isLoading: false,
    // エラー内容
    error: null,
    // アップロード履歴
    history: [],
  },

  // Reducer
  reducers: {
    // 通信開始
    fetchStart(state) {
      state.isLoading = true;
    },
    // 通信失敗
    fetchFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    // 通信成功
    fetchSuccess(state, action) {
      state.error = null;
      state.isLoading = false;
      const newHistory = [...action.payload].concat([...state.history]);
      state.history = newHistory;
    },
    // クリア
    fetchClear(state) {
      state.error = null;
      state.isLoading = false;
      state.history = [];
    },
  },
});

/**
 * Actions.
 *
 * @type {object}
 */
export const {
  fetchStart,
  fetchFailure,
  fetchSuccess,
  fetchClear,
} = slice.actions;

/**
 * Selectors.
 *
 * @type {function}
 */
export const selector = (stateAll) =>
  // すべてのStoreのStateが含まれているため、特定のStoreのStateのみ返す
  stateAll[storeKeyName.register];

/**
 * fetchRegisterFile.
 *
 */
export const fetchRegisterFile = (filePrefix, files) => async (dispatch) => {
  // 通信開始
  dispatch(fetchStart());

  const history = [];
  const uploadFiles = files.map((file) => ({ file, filePrefix }));
  const total = uploadFiles.length;
  let success = 0;

  // 1ファイルごとにアップロードを実行し、DB登録完了を待ち合わせ
  // eslint-disable-next-line no-restricted-syntax
  for (const file of uploadFiles) {
    // eslint-disable-next-line no-await-in-loop
    const { data, error } = await executeUploadZip(file).catch(handleError);
    if (error) {
      dispatch(fetchFailure(error));
      return;
    }
    history.unshift(data);

    // DB登録に失敗した場合、後続のファイル処理を中断
    if (data.result === false) {
      break;
    }

    success += 1;
  }

  // 最後にアップロードファイルの総数と成功数を記録
  const timestamp = formatTZ(new Date(), "yyyy-MM-dd HH:mm:ss", {
    timeZone: "Asia/Tokyo",
  });
  history.unshift({ timestamp, total, success });
  dispatch(fetchSuccess(history));
};

/**
 * fetchRegisterCurveDataFile.
 *
 */
export const fetchRegisterCurveDataFile = (filePrefix, files) => async (
  dispatch
) => {
  const uploadFiles = files.map((file) => ({ file, filePrefix }));
  const responses = await promise
    .map(uploadFiles, executeUploadFile, {
      concurrency: 5,
    })
    .catch(handleError);

  const promiseMapError = checkPromiseMapError(responses);
  if (promiseMapError) {
    dispatch(fetchFailure(promiseMapError));
    return;
  }

  dispatch(fetchSuccess());
};
